import React from 'react';
import {IIconProps} from "../../../../ui/svg/interfaces";
const VisitChainArrowIcon = (props: IIconProps) => {
  return (

    <svg xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height} viewBox="0 0 7 10" fill="none">
        <path fillRule="evenodd" clipRule="evenodd" d="M1.78387 0.743279C1.45535 0.414757 0.922714 0.414757 0.594192 0.743278C0.265924 1.07155 0.265634 1.60368 0.593544 1.93231L3.86225 5.20815L0.593543 8.484C0.265633 8.81262 0.265924 9.34476 0.594192 9.67303C0.922714 10.0016 1.45535 10.0016 1.78387 9.67303L6.24875 5.20815L1.78387 0.743279Z" fill={props.color}/>
    </svg>
  )
};

export default VisitChainArrowIcon;